//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import access from "config/access";
import { toast } from "react-toastify";
import * as moment from "moment";
import { parseISO } from "date-fns";
import { useTranslation } from 'react-i18next';

// custom pages
import Table from "components/Table/Table";
import MemberDetailsAPI from "apis/memberDetails/memberDetails";
import Context from "context/context";
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from "./styles";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import MenuItem from "@material-ui/core/MenuItem";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import EditIcon from "@material-ui/icons/Edit";
import { isBefore } from "date-fns";

//Helpers
import useDebounce from "helpers/useDebounce";
import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { enUS, fr } from "date-fns/locale";
import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
import { exportHeadersCA,exportHeadersUS } from "./export";
import { CSVLink } from "react-csv";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import editIcon from 'assets/img/editIcon.png';



// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#2F7CBD",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#2F7CBD",
      border: "6px solid #2F7CBD",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid gray`,
    backgroundColor: "gray",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function ShiptoDetails() {
  const {
    getAPI,
    searchAPI,
    getReasonDescriptionAPI,
    deactivationAPI,
    changeAccountAPI,
    memberAccountDetailsFilterAPI,
    memberAccountDetailsExportAPI,
    earnAPI,
    updatecdrAPI
  } = MemberDetailsAPI();
  const { state, dispatch } = useContext(Context);
  const classes = Styles();
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [response, setResponse] = useState({
    filter: false,
  });
  const [filterCard, setFilterCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [cdr, setCdr] = useState({});
const [editRowId, setEditRowId] = useState(null); 



  const { t, i18n } = useTranslation()

  let searchBounceValues = useDebounce(() => {
    return searchValue === "" ? "" : searchValue;
  });

  // Set For Deactivation
  const [updateObj, setUpdateObj] = useState({
    index: 0,
    loyaltyDetails: {},
    modal: false,
    modalEarning:false,
    deactiveDate: moment(new Date()).format("YYYY-MM-DD"),
    adminDeactiveDate:moment().add(1, 'days').format('YYYY-MM-DD'),   
    updateReason: "",
    otherReason: false,
    type: "",
  });
  // const [mixedCodeDialog, setMixedCodeDialog] = useState({
  //   open: false,
  //   obj: {},
  //   index: null,
  // });
  // Change Account
  const [changeAccountObj, setChangeAccountObj] = useState({
    index: 0,
    loyaltyDetails: {},
    modal: false,
    updateReason: "",
    otherReason: false,
    editObj: {},
  });

  // Common State Object
  const [states, setstates] = useState({
    reasonDescription: [],
    clearSearch: false,
    status:"",
    deactived:"",
    startDate:null,
    endDate:null,
    account:"",
    accountCreatedBy:"",
    dormant:"",
    nonPoints:"",
    consented:""
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { reasonDescription, clearSearch } = states;

  // Page Path Name
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Member Account Details"],
    });
    handleGetReason();
  }, []);

  // Get Reasons API
  const handleGetReason = async () => {
    try {
      let res = await getReasonDescriptionAPI();
      if (res) {
        setStates({ reasonDescription: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // Handling Get and Search API
  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      } else if(states.filter){
        handleFilter();
      }else {
        getDetails();
      }
    } else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset]);

  // Get API Func
  async function getDetails() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
      setUpdateLoading(false);
    } catch (e) {
      console.log({ e });
    }
  }

  // Search API Func
  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  let isRole10 = state?.userInfo?.role_id === 10;

  // Data Table Headings
  let tableHeading = state?.userInfo?.loyalty_organization_name=='Henry Schein Canada' ? [
    'Member ID',
    "Billto",
    "Enrollment / Transfer",
    "Account Created By",
    "Status",
    "Deactivated",
    // "Start Date",
    "Deactivation Date",
    "Set For Deactivation",
    "DSM/MM Account",
    "Move to Non-Points",
      ...(isRole10 ? ['cdr_gep'] : []),
  ]:[
    'Member ID',
    "Billto",
    "Status",
   "System Managed",
   "Consented",
   "Enrollment Date",
   "Consented Date",
   "Dormant Start",
   "Points Reactivated",
   "Deactivation Date",
   "Set For Deactivation",
   "Non-Points",
   ...(isRole10 ? ['cdr_gep'] : []),
  ]

  const locale = i18n.language == 'fr' ? fr : enUS;

  // Table Pagination Func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // filter function
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
     
      if(states?.startDate=="Invalid Date"||states?.endDate=="Invalid Date"){
        toast.error("Invalid Date Format");
        setStates({ loading: false });
        return;
      }
      if (states?.status) {
       
        values = { ...values, status: states?.status };
       
      }
      if (states?.deactived) {
      
          values = { ...values, deactived: states?.deactived };
      
      }
      // if (states?.startDate) {
      //   values = {
      //     ...values,
      //     deactive_date: states?.startDate
      //   };
      // }
      if (states?.endDate) {
        values = {
          ...values,
          admin_deactive_date: states?.endDate,
        };
      }
      if (states?.account) {
        values = {
          ...values,
          account: states?.account,
        };
      }
      if (states?.accountCreatedBy) {
        values = {
          ...values,
          accountCreatedBy: states?.accountCreatedBy,
        };
      }
      if (states?.dormant) {
        values = {
          ...values,
          dormant: states?.dormant,
        };
      }
      if (states?.nonPoints) {
        values = {
          ...values,
          nonPoints: states?.nonPoints,
        };
      }
      if (states?.consented) {
        values = {
          ...values,
          consented: states?.consented,
        };
      }
     console.log(states?.dormant,"states?.dormant",values)
     
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await memberAccountDetailsFilterAPI(values);
      if (res.data.length > 0) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        setStates({ editObj: "" })
        dispatch({ type: "SET_LOADING", payload: false });
      }
      else {
        setData([]);
        setFilterCard(false);
        setResponse({ filter: true });
        setStates({ editObj: "" })
        dispatch({ type: "SET_LOADING", payload: false });
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
      }
    } catch (e) {
      console.log({ e });
    }
  };
//export function
  const handleExport = async () => {
    let values ;
    if (searchValue) {
      values = { ...values, search:searchValue };
    }
    if(states?.startDate=="Invalid Date"||states?.endDate=="Invalid Date"){
      toast.error("Invalid Date Format");
      setStates({ loading: false });
      return;
    }
    if (states?.status) {
     
      values = { ...values, status: states?.status };
     
    }
    if (states?.deactived) {
    
        values = { ...values, deactived: states?.deactived };
    
    }
    // if (states?.startDate) {
    //   values = {
    //     ...values,
    //     deactive_date: states?.startDate
    //   };
    // }
    if (states?.endDate) {
      values = {
        ...values,
        admin_deactive_date: states?.endDate,
      };
    }
    if (states?.account) {
      values = {
        ...values,
        account: states?.account,
      };
    }
    if (states?.accountCreatedBy) {
      values = {
        ...values,
        accountCreatedBy: states?.accountCreatedBy,
      };
    }
    if (states?.dormant) {
      values = {
        ...values,
        dormant: states?.dormant,
      };
    }
    if (states?.nonPoints) {
      values = {
        ...values,
        nonPoints: states?.nonPoints,
      };
    }
    if (states?.consented) {
      values = {
        ...values,
        consented: states?.consented,
      };
    }
   
    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);
    let res = await memberAccountDetailsExportAPI(values);
    if (res && res.data) {
      if(state?.userInfo?.loyalty_organization_name=='Henry Schein Canada'){
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            member_account_created_by: obj?.member_account_created_by === 1
            ? t("Enrollment")
            : obj?.member_account_created_by === 2
              ? t("Transfer")
              : obj?.member_account_created_by === 3
                ? t("Manual Enrollment")
                : obj?.member_account_created_by === 4
                  ? t("Manual Transfer")
                  : "-",
                  is_active: obj?.is_active?t("Active"):t("Deactive"),
                  account_disabled: obj?.account_disabled?t("Yes"):t("No"),
                  mktcls_modified: obj?.mktcls_modified?t("Yes"):t("No"),
                  mktcls_modified1: (obj?.mktcls_modified || obj?.account_disabled) ?t("Yes"):t("No"),
                  // deactive_date: obj?.deactive_date?obj?.deactive_date:"-",
                  admin_deactive_date: obj?.admin_deactive_date?obj?.admin_deactive_date:"-",
                
  
          }
        }));

      }else{
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            member_account_created_by: obj?.member_account_created_by === 1
            ? t("Enrollment")
            : obj?.member_account_created_by === 2
              ? t("Transfer")
              : obj?.member_account_created_by === 3
                ? t("Manual Enrollment")
                : obj?.member_account_created_by === 4
                  ? t("Manual Transfer")
                  : "-",
                  is_active: obj?.is_active?obj?.dormant_account_flag?t("Active-Dormant"):t("Active"):t("Deactive"),
                  account_disabled: obj?.account_disabled?t("Yes"):t("No"),
                  mktcls_modified: obj?.mktcls_modified?t("Yes"):t("No"),
                  mktcls_modified1: (obj?.mktcls_modified || obj?.account_disabled) ?t("Yes"):t("No"),
                  // deactive_date: obj?.deactive_date?obj?.deactive_date:"-",
                  admin_deactive_date: obj?.admin_deactive_date?obj?.admin_deactive_date:"-",
                  consent_flag: obj?.consent_flag?t("Yes"):t("No"),
                  system_managed: obj?.system_managed?obj?.system_managed:"-",
                  signup_date: obj?.signup_date?obj?.signup_date:"-",
                  consent_date: obj?.consent_date?obj?.consent_date:"-",
                  dormant_paused_date: obj?.dormant_paused_date?obj?.dormant_paused_date:"-",
                  reactivation_date: obj?.reactivation_date?obj?.reactivation_date:"-",
  
          }
        }));
      }
      

      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };
 

  // Set For Deactivation API Func
  const handleDeactivation = async () => {
    toast.dismiss();
    try {
      setUpdateLoading(true);
      let values = {};

      values = {
        loyaltyId: updateObj?.loyaltyDetails?.loyalty_id,
        updateReason: updateObj?.updateReason,
        type: updateObj?.type,
      };

      if (
        updateObj?.type === "DEACTIVE-SET" ||
        updateObj?.type === "DEACTIVE-UPDATE"
      ) {
        values = {
          ...values,
          deactiveDate: updateObj?.adminDeactiveDate,
          adminDeactiveDate: updateObj?.adminDeactiveDate,
        };
      }

      let res = await deactivationAPI(values);
      if (res) {
        let msg = "";
        if (updateObj?.type === "DEACTIVE-SET") {
          msg = "Deactivation Initiated";
        }
        if (updateObj?.type === "DEACTIVE-UPDATE") {
          msg = "Changes Updated";
        }
        if (updateObj?.type === "DEACTIVE-CANCEL") {
          msg = "Deactivation Cancelled";
        }
        toast.success(msg, { tostId: "update-success" });
        setUpdateObj({
          index: 0,
          loyaltyDetails: {},
          modal: false,
          modalEarning:false,
          deactiveDate: moment(new Date()).format("YYYY-MM-DD"),
          adminDeactiveDate: moment().add(1, 'days').format('YYYY-MM-DD'),
          updateReason: "",
          otherReason: false,
          type: "",
        });
        if (offset === 1) {
          getDetails();
        } else {
          setOffset(1);
        }
      }
    } catch (e) {
      console.log("errors");
    }
  };
  const handleEarn = async () => {
    toast.dismiss();
    try {
      setUpdateLoading(true);
      let values = {};

      values = {
        loyaltyId: updateObj?.loyaltyDetails?.loyalty_id,
      
      };
 

     

      let res = await earnAPI(values);
      if (res) {
        let msg = "Account successfully moved from Non-Earning to Earning";
        
       
        toast.success(msg, { tostId: "update-success" });
        setUpdateObj({          
          modalEarning:false,          
        });
        if (offset === 1) {
          getDetails();
        } else {
          setOffset(1);
        }
      }
    } catch (e) {
      console.log("errors");
    }
  };

  const handleUpdate = async (cdr,id) => {
    toast.dismiss();
    try {
     
      let values = {};

      values = {
        id:id,
       cdr

      };

     

      let res = await updatecdrAPI(values);
      if (res && res?.type === "SUCCESS") {
        // setEditObj({})
        
       
        if (offset === 1) {
          getDetails();
        } else {
          setOffset(1);
        }
      }
      setUpdateLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  // Change Accounnt API Func
  const handleChangeAccount = async () => {
    try {

      setUpdateLoading(true);
    
      let values = {};

      values = {
        loyaltyId: changeAccountObj?.loyaltyDetails?.loyalty_id,
        updateReason: changeAccountObj?.updateReason,
      };

      let res = await changeAccountAPI(values);

      if (res) {
        toast.success("Account Changed Succcessfully", {
          tostId: "update-success",
        });
        setChangeAccountObj({
          index: 0,
          loyaltyDetails: {},
          modal: false,
          updateReason: "",
          otherReason: false,
        });
        if (offset === 1) {
          getDetails();
        } else {
          setOffset(1);
        }
      }
    } catch (e) {
      console.log("errors");
    }
  };

  return (
    <Fragment>
      <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
        <div style={{ flex: 0.99 }}>
        <CssTextField
          id="search"
          placeholder={t('Search for Member Id')}
          onKeyDown={blockInvalidChar}
          type={"number"}
              onWheel={(e) => e.target.blur()}
          variant="outlined"
          autoComplete="off"
          className={classes.searchInput}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchValue.length > 0 ? (
                  <CloseOutlinedIcon
                    className={classes.searchInputIcon}
                    onClick={() => {
                      setStates({ clearSearch: true });
                      setSearchValue("");
                      if (offset === 1) {
                        getDetails();
                      } else {
                        setOffset(1);
                      }
                    }}
                  />
                ) : (
                  <img
                    src={searchIcon}
                    alt=""
                    width="20px"
                    className={classes.searchInputIcon}
                  />
                )}
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => {
            e.target.value.replace(/\s+/g, "").length == 0
              ? setSearchValue("")
              : setSearchValue(e.target.value);
            setOffset(1);
            if (e.target.value.length == 0) {
              getDetails();
            }
          }}
          onClick={() => { }}
        />
  
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              setFilterCard(!filterCard);
              if (!states?.filter) {
                setStates({
              status:""
                });
              }
            }}
          >
           {t('Filter')} 
            {response["filter"] && (
              <Badge
                badgeContent={count == 0 ? null : response["filter"] && count}
                color="error"
                classes={{ badge: classes.badge }}
                max={999999}
                className={classes.badges}
              ></Badge>
            )}
          </Button>          
        
        </div>
        <CSVLink
          id="csv"
          data={exportData}
          headers={state?.userInfo?.loyalty_organization_name=='Henry Schein Canada' ?exportHeadersCA.map((head) => head):exportHeadersUS.map((head) => head)}
          filename={`Member-Details-` + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"}
          className={classes.CSVlink}
        />
        <button
          disabled={isLoading}
          className={classes.exportBtn}
          onClick={async () => {
            let res = await handleExport();
            if (res) {
              document.getElementById("csv").click();
            }
          }}
        >
          {isLoading ? (
            <div class="snippet" style={{ marginLeft: 50 }}>
              <div class="stage">
                <div class="dot-typing-e"></div>
              </div>
            </div>
          ) :
            `Export`
          }
        </button>
      </Grid>
        
        {filterCard && (
        <div className={classes.filterCardDiv}>
           {state?.userInfo?.loyalty_organization_name=='Henry Schein Canada' ?
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Status")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.status}
                      onChange={(e) => {
                        setStates({ status: e.target.value });
                      }}
                    >
                      <MenuItem value={'true'}>{t("Active")}</MenuItem>
                      <MenuItem value={'false'}>{t('Deactive')}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Deactivated')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.deactived}
                      onChange={(e) => {
                        setStates({ deactived: e.target.value });
                      }}
                    >
                  <MenuItem value={'true'}>{t("Yes")}</MenuItem>
                      <MenuItem value={'false'}>{t("No")}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("DSM/MM Account")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.account}
                      onChange={(e) => {
                        setStates({ account: e.target.value });
                      }}
                    >
                      <MenuItem value={'true'}>{t("Yes")}</MenuItem>
                      <MenuItem value={'false'}>{t("No")}</MenuItem>
                    </TextField>
                  </Grid>
                
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Deactivation Date")}</div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="dense"
                        id="date-picker-inline2"
                        className={classes.dateInput}
                        value={states.endDate}
                        onChange={(date) => {
                          // if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate).format("MM/DD/YYYY"))) {
                          //   toast.error(
                          //     "End date should be greater than Start date.",
                          //     {
                          //       toastId: "start-date-end-date",
                          //     }
                          //   );
                          //   setStates({ endDate: null });
                          //   return;
                          // }
                          setStates({ endDate: date, dateApplied: true });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Enrollment / Transfer")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.accountCreatedBy}
                      onChange={(e) => {
                        setStates({ accountCreatedBy: e.target.value });
                      }}
                    >
                      <MenuItem value={1}>{t("Enrollment")}</MenuItem>
                      <MenuItem value={2}>{t("Transfer")}</MenuItem>
                      <MenuItem value={3}>{t("Manual Enrollment")}</MenuItem>
                      <MenuItem value={4}>{t("Manual Transfer")}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            if (
                              !states?.status &&
                              !states?.deactived &&
                              !states?.endDate &&
                              !states?.startDate &&
                              !states?.account &&
                              !states?.accountCreatedBy
                            ) {
                              toast.error("Please select atleast one field.");
                              return;
                            }
                      
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                        {t('Apply')}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                              status:"",
                              deactived:"",
                              startDate:null,
                              endDate:null,
                              account:"",
                              accountCreatedBy:"",                              
                               dormant:"",
                               nonPoints:"",
                               consented:""
                              });
                              setOffset(1);
                              setFilterCard(false);
                              getDetails();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                               {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                 
                </Grid>
              </Card>
            </Grid>
          </Grid>:<Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Status")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.status}
                      onChange={(e) => {
                        setStates({ status: e.target.value });
                      }}
                    >
                      <MenuItem value={'true'}>{t("Active")}</MenuItem>
                      <MenuItem value={'false'}>{t('Deactive')}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Consented')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.consented}
                      onChange={(e) => {
                        setStates({ consented: e.target.value });
                      }}
                    >
                  <MenuItem value={'true'}>{t("Yes")}</MenuItem>
                      <MenuItem value={'false'}>{t("No")}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Non-Points")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.nonPoints}
                      onChange={(e) => {
                        setStates({ nonPoints: e.target.value });
                      }}
                    >
                      <MenuItem value={'true'}>{t("Yes")}</MenuItem>
                      <MenuItem value={'false'}>{t("No")}</MenuItem>
                    </TextField>
                  </Grid>
                
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Deactivation Date")}</div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="dense"
                        id="date-picker-inline2"
                        className={classes.dateInput}
                        value={states.endDate}
                        onChange={(date) => {
                          // if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate).format("MM/DD/YYYY"))) {
                          //   toast.error(
                          //     "End date should be greater than Start date.",
                          //     {
                          //       toastId: "start-date-end-date",
                          //     }
                          //   );
                          //   setStates({ endDate: null });
                          //   return;
                          // }
                          setStates({ endDate: date, dateApplied: true });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Dormant Account")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.dormant}
                      onChange={(e) => {
                        setStates({ dormant: e.target.value });
                      }}
                    >
                      <MenuItem value={'Dormant'}>{t("Dormant")}</MenuItem>
                      <MenuItem value={'Reactivated'}>{t("Reactivated")}</MenuItem>

                    </TextField>
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            if (
                              !states?.status &&
                              !states?.deactived &&
                              !states?.endDate &&
                              !states?.startDate &&
                              !states?.account &&
                              !states?.accountCreatedBy&&
                              !states?.dormant&&
                              !states?.consented&&
                              !states?.nonPoints
                            ) {
                              toast.error("Please select atleast one field.");
                              return;
                            }
                      
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                        {t('Apply')}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                              status:"",
                              deactived:"",
                              startDate:null,
                              endDate:null,
                              account:"",
                              accountCreatedBy:"",                         
                                dormant:"",
                                nonPoints:"",
                                consented:""
                                        });
                              setOffset(1);
                              setFilterCard(false);
                              getDetails();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                               {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                 
                </Grid>
              </Card>
            </Grid>
          </Grid>}
        </div>
        )}
          

      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            // headings={tableHeading.map((i) => {
            //   return <div key={t(i)}>{t(i)}</div>;
            // })}
            headings={tableHeading.map((i) => (
              <div
                key={t(i)}

                style={
                  state?.userInfo?.loyalty_organization_name === 'Henry Schein Canada' && state?.userInfo?.role_id === 10
                    ? { width: '140px' }
                    : state?.userInfo?.loyalty_organization_name === 'Henry Schein dental' && state?.userInfo?.role_id === 10
                    ? { width: '140px' }
                    : state?.userInfo?.loyalty_organization_name === 'Henry Schein Canada' && state?.userInfo?.role_id !== 10
                    ? { width: '80px' }
                    : state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.userInfo?.role_id !== 10
                    ? { width: '137px' }
                    : { width: '137px' } // default fallback
                }
                
                // style={
                //   state?.userInfo?.loyalty_organization_name=='Henry Schein Canada' ?{}: { width: '140px' } 
                // }
              >
                {t(i)}
              </div>
            ))}
            data={state?.userInfo?.loyalty_organization_name=='Henry Schein Canada' ?
            data.map((d, i) => [
              d?.loyalty_id,
              d?.customer_billto_account_number,
              d?.member_account_created_by === 1
                ? t("Enrollment")
                : d?.member_account_created_by === 2
                  ? t("Transfer")
                  : d?.member_account_created_by === 3
                    ? t("Manual Enrollment")
                    : d?.member_account_created_by === 4
                      ? t("Manual Transfer")
                      : "-",
              d?.request_by,
              d?.is_active ? (
                <span className={classes.greenBtn}>{t("Active")}</span>
              ) : (
                <span className={classes.redBtn}>{t('Deactive')}</span>
              ),
              d?.account_disabled ? (
                <span className={classes.redBtn}>{t("Yes")}</span>
              ) : (
                <span className={classes.greenBtn}>{t("No")}</span>
              ),
              // d?.deactive_date ? (
              //   <span>
              //     {moment(d?.deactive_date).format("MM/DD/yyyy")}&nbsp;
              //     {!d?.account_disabled && (
              //       <EditIcon
              //         className={classes.editIcon}
              //         onClick={() => {
              //           setUpdateObj({
              //             ...updateObj,
              //             loyaltyDetails: d,
              //             modal: true,
              //             deactiveDate: d?.admin_deactive_date,
              //             adminDeactiveDate: d?.admin_deactive_date,
              //             type: "DEACTIVE-UPDATE",
              //           });
              //         }}
              //       />
              //     )}
              //   </span>
              // ) : (
              //   "-"
              // ),
              d?.admin_deactive_date ? (
                <span>
                  {moment(d?.admin_deactive_date).format("MM/DD/yyyy")}&nbsp;
                  {!d?.account_disabled && (
                    <EditIcon
                      className={classes.editIcon}
                      onClick={() => {
                        setUpdateObj({
                          ...updateObj,
                          loyaltyDetails: d,
                          modal: true,
                          deactiveDate: d?.admin_deactive_date,
                          adminDeactiveDate: d?.admin_deactive_date,
                          type: "DEACTIVE-UPDATE",
                        });
                      }}
                    />
                  )}
                </span>
              ) : (
                "-"
              ),
              d?.account_disabled ? (
                <div style={{ margin: 8 }}>-</div>
              ) : (
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={d?.checked}

                      // disabled={!access['editAccess'][state.userInfo?.role]['member-details']}
                      onChange={()=>{
                       
                        if(state?.userInfo?.editAction ){
                        if (d?.checked) {
                          setUpdateObj({
                            ...updateObj,
                            index: i,
                            loyaltyDetails: d,
                            modal: true,
                            type: "DEACTIVE-CANCEL",
                          });
                        } else {
                          setUpdateObj({
                            ...updateObj,
                            index: i,
                            loyaltyDetails: d,
                            modal: true,
                            type: "DEACTIVE-SET",
                          });
                        }
                        setData([
                          ...data.slice(0, i),
                          { ...data[i], checked: !d?.checked },
                          ...data.slice(i + 1),
                        ]);
                        return;
                      }  else{
                        toast.error(state.userInfo?.editAccess)
                      return;
                    }}}
                      name=""
                    />
                  }
                />
              ),
              d?.mktcls_modified ? (
                <span className={classes.redBtn}>{t('No')}</span>
              ) : (
                <span className={classes.greenBtn}>{t('Yes')}</span>
              ),
              d?.mktcls_modified || d?.account_disabled ? (
                state?.userInfo?.role_id == 10?<EditIcon
                  className={classes.editIcon}
                  onClick={() => {
                    setUpdateObj({
                      ...updateObj,
                      loyaltyDetails: d,
                      modalEarning: true,
                      type: "EARNING-UPDATE",
                    });
                  }}
                />:<div style={{ margin: 8 }}>-</div>
              ) : (
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={d?.change_account}

                      // disabled={!access['editAccess'][state.userInfo?.role]['member-details']}
                      onChange={()=> {
                      
                        if(state?.userInfo?.editAction){
                         
                          // if(d?.signature_flag==true){
                          //   toast.error("failed")
                          // }
                        if (!d?.change_account) {
                          setChangeAccountObj({
                            ...changeAccountObj,
                            index: i,
                            loyaltyDetails: d,
                            modal: true,
                          });
                          setData([
                            ...data.slice(0, i),
                            {
                              ...data[i],
                              change_account: !d?.change_account,
                            },
                            ...data.slice(i + 1),
                          ]);
                        }
                        return;
                      }
                    else{
                      toast.error(state.userInfo?.editAccess)
                    return;
                  }}}
                      name=""
                    />
                  }
                />
              ),

             
                
              ...(state?.userInfo?.role_id === 10 ?
                [<div>{
                  // Column 1: Editable Date or Display
                  editRowId === d?.loyalty_id ? (
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="cdr-gep-picker"
                        // minDate={new Date()} // ✅ disables past dates
                        label=""
                        value={cdr?.cdr_gep || null}
                        onChange={(date) => {
                          if (date === null) {
                            setCdr({ ...cdr, cdr_gep: null });
                          } else {
                            setCdr({ ...cdr, cdr_gep: moment(date).format("YYYY-MM-DD") });
                          }
                        }}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        autoOk
                        style={{ width: '100%' }}
                        InputProps={{
                          classes: {
                            root: classes?.dateInputTexts,
                          },
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  ) : (
                    d?.cdr_gep ? (
                      <span>{moment(d?.cdr_gep).format("MM/DD/yyyy")}</span>
                    ) : (
                      <span>-</span>
                    )
                  )},
              
                  {// Column 2: Icons
                  editRowId === d?.loyalty_id ? (
                    <>
                      <CheckCircleOutlineIcon
                        style={{
                          cursor: 'pointer',
                          color: 'green',
                          margin: '0px 5px',
                          fontSize: 35,
                        }}
                        onClick={() => {
                          const originalDate = moment(d?.cdr_gep).format("YYYY-MM-DD");
                          const updatedDate = moment(cdr?.cdr_gep).format("YYYY-MM-DD");
              
                          if (originalDate === updatedDate) {
                            toast.success("Change any field");
                            return;
                          }
              
                          handleUpdate(cdr, d?.loyalty_id);
                          toast.success("Updated");
                          setEditRowId(null);
                          setCdr({});
                        }}
                      />
                      <HighlightOffIcon
                        style={{
                          cursor: 'pointer',
                          color: 'red',
                          margin: '0px 5px',
                          fontSize: 35,
                        }}
                        onClick={() => {
                          setEditRowId(null);
                          setCdr({});
                        }}
                      />
                    </>
                  ) : (
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setEditRowId(d?.loyalty_id);
                        setCdr({ cdr_gep: d?.cdr_gep || null });
                      }}
                    >
                      <img src={editIcon} alt="" width="20" />
                    </div>
                  )}
                </div>]
                : 
                [] // Do not add CDR GEP data for non-role-10 users
              )
              

            ]):data.map((d, i) => [
                d?.loyalty_id,
                d?.customer_billto_account_number,
                                d?.is_active ? (
                                  d?.dormant_account_flag?
                  <span  className={classes.greenBtn}>{t("Active-Dormant")}</span>:
                  <span className={classes.greenBtn}>{t("Active")}</span>

                ) : (
                  <span className={classes.redBtn}>{t('Deactive')}</span>
                ),
                d?.system_managed,
                d?.consent_flag ? (
                  <span >{t("Yes")}</span>
                ) : (
                  <span >{t('No')}</span>
                ),
                d?.signup_date?d?.signup_date:(<div style={{ margin: 8 }}>-</div>),
                d?.consent_date? d?.consent_date:(<div style={{ margin: 8 }}>-</div>),
                d?.dormant_paused_date?  d?.dormant_paused_date :(<div style={{ margin: 8 }}>-</div>),
                d?.reactivation_date?  d?.reactivation_date :(<div style={{ margin: 8 }}>-</div>),         

                d?.admin_deactive_date ? (
                  <span>
                    {moment(d?.admin_deactive_date).format("MM/DD/yyyy")}&nbsp;
                    {!d?.account_disabled && (
                      <EditIcon
                        className={classes.editIcon}
                        onClick={() => {
                          setUpdateObj({
                            ...updateObj,
                            loyaltyDetails: d,
                            modal: true,
                            deactiveDate: d?.admin_deactive_date,
                            adminDeactiveDate: d?.admin_deactive_date,
                            type: "DEACTIVE-UPDATE",
                          });
                        }}
                      />
                    )}
                  </span>
                ) : (
                  "-"
                ),
                d?.account_disabled ? (
                  <div style={{ margin: 8 }}>-</div>
                ) : (
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={d?.checked}
                        // disabled={!access['editAccess'][state.userInfo?.role]['member-details']}
                        onChange={()=>{
                          if(state?.userInfo?.editAction ){
                          if (d?.checked) {
                            setUpdateObj({
                              ...updateObj,
                              index: i,
                              loyaltyDetails: d,
                              modal: true,
                              type: "DEACTIVE-CANCEL",
                            });
                          } else {
                            setUpdateObj({
                              ...updateObj,
                              index: i,
                              loyaltyDetails: d,
                              modal: true,
                              type: "DEACTIVE-SET",
                            });
                          }
                          setData([
                            ...data.slice(0, i),
                            { ...data[i], checked: !d?.checked },
                            ...data.slice(i + 1),
                          ]);
                          return;
                        }  else{
                          toast.error(state.userInfo?.editAccess)
                        return;
                      }}}
                        name=""
                      />
                    }
                  />
                ),
               
                d?.mktcls_modified || d?.account_disabled ? (
                  (
                    <span className={classes.greenBtn}>{state?.userInfo?.role_id == 10?<EditIcon
                    className={classes.editIcon}
                    onClick={() => {
                      setUpdateObj({
                        ...updateObj,
                        loyaltyDetails: d,
                        modalEarning: true,
                        type: "EARNING-UPDATE",
                      });
                    }}
                  />:t("Yes")}</span>
                  )
                ) : (
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={d?.change_account}
                        // disabled={!access['editAccess'][state.userInfo?.role]['member-details']}
                        onChange={()=> {
                          if(state?.userInfo?.editAction){
                            if (
                              state.userInfo?.loyalty_organization_name === "Henry Schein Dental" &&
                              !d?.tier
                            ) {
                              toast.error("Cannot change the account to non-points earning status until the tier is assigned.", {
                                toastId: "missing-tier-error",
                              });
                              return;

                            }
                             if(d?.signature_flag==true && d?.unlocked_subscription_is_active==true ){
                              toast.error('This member has an active Unlock subscription. Please end the Unlock subscription and wait until the subscription end date has passed to convert this account to Non-Points Earning.')
                            }
                            if(d?.signature_flag==true && !d?.unlocked_subscription_is_active){
                              toast.error('This member has an active Signature subscription. Please end the Signature subscription and wait until the subscription end date has passed to convert this account to Non-Points Earning.')
                            }
                            if(d?.subscription_is_active == true){
                              toast.error('This member has an active Startup subscription. Please end the Startup subscription and wait until the subscription end date has passed to convert this account to Non-Points Earning.')
                            }

                            console.log(d,"Object")
                          //   const codes = d.privilege_codes
                          //   ? d.privilege_codes.split(",").map((c) => c.trim())
                          //   : [];
                          // console.log(codes,"code")
                          // if (codes.includes("ST3")) {
                          //   // Open mixed code dialog
                          //   setMixedCodeDialog({ open: false, obj: d, index: i });
                          //   return;
                          // }
          
                          if (!d?.change_account && !d?.signature_flag && !d?.subscription_is_active && (!d?.unlocked_subscription_is_active && !d?.signature_flag)  ) {
                            setChangeAccountObj({
                              ...changeAccountObj,
                              index: i,
                              loyaltyDetails: d,
                              modal: true,
                            });
                            setData([
                              ...data.slice(0, i),
                              {
                                ...data[i],
                                change_account: !d?.change_account,
                              },
                              ...data.slice(i + 1),
                            ]);
                          }
                          return;
                        }
                      else{
                        toast.error(state.userInfo?.editAccess)
                      return;
                    }}}
                        name=""
                      />
                    }
                  />
                ),

                ...(state?.userInfo?.role_id === 10 ?
                  [
                    // Column 1: Editable Date or Display
                    <div>
                    {editRowId === d?.loyalty_id ? (
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          format="MM/dd/yyyy"
                          margin="normal"
                          id="cdr-gep-picker"
                          // minDate={new Date()} // ✅ disables past dates
                          label=""
                          value={cdr?.cdr_gep || null}
                          onChange={(date) => {
                            if (date === null) {
                              setCdr({ ...cdr, cdr_gep: null });
                            } else {
                              setCdr({ ...cdr, cdr_gep: moment(date).format("YYYY-MM-DD") });
                            }
                          }}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          autoOk
                          style={{ width: '100%' }}
                          InputProps={{
                            classes: {
                              root: classes?.dateInputTexts,
                            },
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    ) : (
                      d?.cdr_gep ? (
                        <span>{moment(d?.cdr_gep).format("MM/DD/yyyy")}</span>
                      ) : (
                        <span>-</span>
                      )
                    )},
                
                    {// Column 2: Icons
                    editRowId === d?.loyalty_id ? (
                      <>
                        <CheckCircleOutlineIcon
                          style={{
                            cursor: 'pointer',
                            color: 'green',
                            margin: '0px 5px',
                            fontSize: 35,
                          }}
                          onClick={() => {
                            const originalDate = moment(d?.cdr_gep).format("YYYY-MM-DD");
                            const updatedDate = moment(cdr?.cdr_gep).format("YYYY-MM-DD");
                
                            if (originalDate === updatedDate) {
                              toast.success("Change any field");
                              return;
                            }
                
                            handleUpdate(cdr, d?.loyalty_id);
                            toast.success("Updated");
                            setEditRowId(null);
                            setCdr({});
                          }}
                        />
                        <HighlightOffIcon
                          style={{
                            cursor: 'pointer',
                            color: 'red',
                            margin: '0px 5px',
                            fontSize: 35,
                          }}
                          onClick={() => {
                            setEditRowId(null);
                            setCdr({});
                          }}
                        />
                      </>
                    ) : (
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setEditRowId(d?.loyalty_id);
                          setCdr({ cdr_gep: d?.cdr_gep || null });
                        }}
                      >
                        <img src={editIcon} alt="" width="20" />
                      </div>
                    )}
                    </div>
                  ]
                  : 
                  [] // Do not add CDR GEP data for non-role-10 users
                )           
                
                
                
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: "25vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{t('Loading...')}</h2>
          </div>
        )}
      </div>

      {/* Set For Deactivation Dialog */}
      <Dialog
        maxWidth={"xs"}
        aria-labelledby="simple-dialog-title"
        open={updateObj.modal}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>{t('Confirmation')}</div>
          <div className={classes.parentText2}>
            &nbsp;&nbsp;&nbsp;
            {updateObj?.type === "DEACTIVE-SET" ||
              updateObj?.type === "DEACTIVE-UPDATE" ? (
              <span>
                {t('Please set a Deactivation Date for this member. After this date, the member will no longer earn points, access benefits, view their dashboard, or redeem rewards.')}
              </span>
            ) : (
              <span>
                {t('Cancelling will stop the deactivation of')} <br />
                {t('Member Account.')}
              </span>
            )}
          </div>
          <br />
          <Fragment>
            {(updateObj?.type === "DEACTIVE-SET" ||
              updateObj?.type === "DEACTIVE-UPDATE") && (
                <Fragment>
                  {/* <div className={classes.subParentText}>
                    {t('Deactivation Start Date')}&nbsp;
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                      <KeyboardDatePicker
                        disableToolbar
                        inputVariant="outlined"
                        format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                        margin="normal"
                        id="deactive-date"
                        disabled={true}
                        className={classes.dateInput}
                        value={parseISO(updateObj?.adminDeactiveDate)}
                        minDate={new Date()}
                        onChange={(date) => {
                          let d = moment(date).format("YYYY-MM-DD");
                          setUpdateObj({
                            ...updateObj,
                            deactiveDate: d,
                          });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </div> */}
                  <div className={classes.subParentText}>
                    {t('Deactivation Date')}&nbsp;
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                      <KeyboardDatePicker
                        disableToolbar
                        inputVariant="outlined"
                        format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                        margin="normal"
                        id="admin-deactive-date"
                        className={classes.dateInput}
                        value={parseISO(updateObj?.adminDeactiveDate)}
                        minDate={new Date()}
                        shouldDisableDate={(date) => {
                          // Disable the current date
                          return moment(date).isSame(moment(), 'day');
                        }}
                        onChange={(date) => {
                          let d = moment(date).format("YYYY-MM-DD");
                          setUpdateObj({
                            ...updateObj,
                            adminDeactiveDate: d,
                          });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </Fragment>
              )}
            <div className={classes.subParentText}>
              {t('Please choose the reason for updating')}&nbsp;
              <span style={{ color: "red" }}>*</span>
            </div>
            <div>
              <CssTextField
                variant="outlined"
                select
                fullWidth
                className={classes.dialogInput}
                value={
                  updateObj?.otherReason ? "Others" : updateObj?.updateReason
                }
                onChange={(e) => {
                  if (e.target.value === "Others") {
                    setUpdateObj({
                      ...updateObj,
                      otherReason: true,
                      updateReason: "",
                    });
                  } else {
                    setUpdateObj({
                      ...updateObj,
                      updateReason: e.target.value,
                      otherReason: false,
                    });
                  }
                }}
              >
                {[
                  ...reasonDescription.filter(
                    (r) => r?.type === "MEMBER_DETAILS_1"
                  ),
                  { reason_description: "Others" },
                ]?.map((d, i) => (
                  <MenuItem value={d?.reason_description} key={i}>
                    {t(d?.reason_description)}
                  </MenuItem>
                ))}
              </CssTextField>

              {updateObj?.otherReason && (
                <Fragment>
                  <div className={classes.subParentText}>
                    {t('Type the Reason')}&nbsp;<span style={{ color: "red" }}>*</span>
                    &nbsp;
                    <span style={{ fontSize: 12 }}>{t('(Max 120 Characters)')}</span>
                  </div>
                  <CssTextField
                    id="reason"
                    type={"text"}
                    autoComplete="off"
                    variant="outlined"
                    inputProps={{
                      maxLength: 120,
                    }}
                    className={classes.dialogInput}
                    value={updateObj?.updateReason}
                    onChange={(e) => {
                      setUpdateObj({
                        ...updateObj,
                        updateReason: e.target.value,
                      });
                    }}
                  />
                </Fragment>
              )}
            </div>
          </Fragment>
          <br />
          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                {" "}
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      setData([
                        ...data.slice(0, updateObj?.index),
                        {
                          ...data[updateObj?.index],
                          checked: !data[updateObj?.index]?.checked,
                        },
                        ...data.slice(updateObj?.index + 1),
                      ]);
                      setUpdateObj({
                        ...updateObj,
                        index: 0,
                        loyaltyDetails: {},
                        modal: false,
                        deactiveDate: moment(new Date()).format("YYYY-MM-DD"),
                        adminDeactiveDate: moment().add(1, 'days').format('YYYY-MM-DD'),   
                        updateReason: "",
                        otherReason: false,
                      });
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                      if (!updateObj?.updateReason) {
                        toast.dismiss();
                        return toast.error("Please fill the reason", {
                          toastId: "empty-reason",
                        });
                      }
                      if (updateObj?.deactiveDate === "Invalid date") {
                        toast.dismiss();
                        return toast.error("Invalid Deactivation Date", {
                          toastId: "invalid-deactive-date-error",
                        });
                      }
                      if (updateObj?.adminDeactiveDate === "Invalid date") {
                        toast.dismiss();
                        return toast.error("Invalid Admin Deactivation Date", {
                          toastId: "invalid-admin-deactive-date-error",
                        });
                      }
                      if (updateObj?.adminDeactiveDate === moment(new Date()).format("YYYY-MM-DD")) {
                        toast.dismiss();
                        return toast.error("Deactivation Date should be greater than Current Date", {
                          toastId: "invalid-admin-deactive-date-error",
                        });
                      }
                      // if (
                      //   moment(updateObj?.deactiveDate).isBefore(
                      //     moment().format("YYYY-MM-DD")
                      //   )
                      // ) {
                      //   toast.dismiss();
                      //   return toast.error(
                      //     "Deactivation Date should be greater than Current Date",
                      //     { toastId: "deactive-date-error" }
                      //   );
                      // }
                      if (
                        moment(updateObj?.adminDeactiveDate).isBefore(
                          moment().format("YYYY-MM-DD")
                        )
                      ) {
                        toast.dismiss();
                        return toast.error(
                          "Admin Deactivation Date should be greater than Current Date",
                          { toastId: "deactive-date-error" }
                        );
                      }
                      // if (
                      //   moment(updateObj?.deactiveDate).isAfter(
                      //     updateObj?.adminDeactiveDate
                      //   )
                      // ) {
                      //   toast.dismiss();
                      //   return toast.error(
                      //     "Deactivation Date should be lesser than Admin Deactivation Date",
                      //     { toastId: "deactive-date-error" }
                      //   );
                      // }
                      handleDeactivation();
                    }}
                  >
                    {t('Update')}
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>
      <Dialog
        maxWidth={"xs"}
        aria-labelledby="simple-dialog-title"
        open={updateObj.modalEarning}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>{t('Confirmation')}</div>
          <div className={classes.parentText2}>
            &nbsp;&nbsp;&nbsp;
           <span>
                {t('Are you sure you want to move this member account from Non-Earning to Earning?')} <br />
                
              </span>
            
          </div>
          <br />
          
          <br />
          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                {" "}
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      
                      setUpdateObj({
                        ...updateObj,
                        modalEarning: false                      
                        
                      });
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                  
                    
                     
                      handleEarn();
                    }}
                  >
                    {t('Update')}
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>
         {/* Mixed Privilege Code Dialog */}
         {/* <Dialog
        open={mixedCodeDialog.open}
        onClose={() => setMixedCodeDialog({ open: false, obj: {}, index: null })}
        maxWidth="sm"
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div style={{ padding: 20 }}>
          <h2 style={{ marginBottom: 10 }}>
            <span>{t("Mixed Privilege Code Detected")}</span>
          </h2>
          <p>
            {t(
              "The selected member has a combination of privilege codes (e.g., ST3). Do you still want to proceed with moving them to the Non-Points Earning account?"
            )}
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
            <Button
              variant="outlined"
              style={{ marginRight: 10 }}
              onClick={() => setMixedCodeDialog({ open: false, obj: {}, index: null })}
            >
              {t("No")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                // Close mixed dialog
                setMixedCodeDialog({ open: false, obj: {}, index: null });

                // Open change account confirmation dialog
                setChangeAccountObj({
                  index: mixedCodeDialog.index,
                  loyaltyDetails: mixedCodeDialog.obj,
                  modal: true,
                });

                // Optimistically toggle change_account for that index
                setData((oldData) => {
                  const newData = [...oldData];
                  const idx = mixedCodeDialog.index;
                  newData[idx] = {
                    ...newData[idx],
                    change_account: !newData[idx].change_account,
                  };
                  return newData;
                });
              }}
            >
              {t("Yes")}
            </Button>
          </div>
        </div>
      </Dialog> */}

      {/* Change Account Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={changeAccountObj.modal}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={"xs"}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>{t('Confirmation')}</div>
          <div className={classes.parentText2}>
            &nbsp;&nbsp;&nbsp;
            <span>
              Upon setting this member to the non-points program, they will no
              longer participate in earning points in Thrive Rewards. However,
              their other benefits will remain the same.
            </span>
          </div>
          <br />
          <Fragment>
            <div className={classes.subParentText}>
              {t('Please choose the reason for updating')}&nbsp;
              <span style={{ color: "red" }}>*</span>
            </div>
            <div>
              <CssTextField
                variant="outlined"
                select
                fullWidth
                className={classes.dialogInput}
                value={
                  changeAccountObj?.otherReason
                    ? "Others"
                    : changeAccountObj?.updateReason
                }
                onChange={(e) => {
                  if (e.target.value === "Others") {
                    setChangeAccountObj({
                      ...changeAccountObj,
                      otherReason: true,
                      updateReason: "",
                    });
                  } else {
                    setChangeAccountObj({
                      ...changeAccountObj,
                      updateReason: e.target.value,
                      otherReason: false,
                    });
                  }
                }}
              >
                {[
                  ...reasonDescription.filter(
                    (r) => r?.type === "MEMBER_DETAILS_2"
                  ),
                  { reason_description: "Others" },
                ]?.map((d, i) => (
                  <MenuItem value={d?.reason_description} key={i}>
                    {t(d?.reason_description)}
                  </MenuItem>
                ))}
              </CssTextField>

              {changeAccountObj?.otherReason && (
                <Fragment>
                  <div className={classes.subParentText}>
                    {t('Type the Reason')}&nbsp;<span style={{ color: "red" }}>*</span>
                    &nbsp;
                    <span style={{ fontSize: 12 }}>{t('(Max 120 Characters)')}</span>
                  </div>
                  <CssTextField
                    id="reason"
                    type={"text"}
                    autoComplete="off"
                    variant="outlined"
                    inputProps={{
                      maxLength: 120,
                    }}
                    className={classes.dialogInput}
                    value={changeAccountObj?.updateReason}
                    onChange={(e) => {
                      setChangeAccountObj({
                        ...changeAccountObj,
                        updateReason: e.target.value,
                      });
                    }}
                  />
                </Fragment>
              )}
            </div>
          </Fragment>
          <br />
          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                {" "}
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      setData([
                        ...data.slice(0, changeAccountObj?.index),
                        {
                          ...data[changeAccountObj?.index],
                          change_account:
                            !data[changeAccountObj?.index]?.change_account,
                        },
                        ...data.slice(changeAccountObj?.index + 1),
                      ]);
                      setChangeAccountObj({
                        index: 0,
                        loyaltyDetails: {},
                        modal: false,
                        updateReason: "",
                        otherReason: false,
                      });
                    }}
                  >
                    {t('Cancel')}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                      if (!changeAccountObj?.updateReason) {
                        return toast.error("Please fill the reason", {
                          toastId: "empty-reason",
                        });
                      }
                      handleChangeAccount();
                    }}
                  >
                    {t('Update')}
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>
    </Fragment>
  );
}
